<template>
  <CDropdown
    inNav
    class="c-header-nav-items preika-account-menu"
    placement="bottom-end"
    add-menu-classes="preika-account-dropdown"
  >
    <template #toggler>
      <CHeaderNavLink class="preika-account-trigger" aria-label="アカウントメニュー">
        <span class="preika-account-avatar">{{ userInitial }}</span>
        <span class="preika-account-copy d-md-down-none">
          <strong>{{ name || 'ユーザー' }}</strong>
          <small>{{ authorityName || 'PREIKA' }}</small>
        </span>
        <CIcon name="cil-chevron-bottom" class="preika-account-chevron d-md-down-none"/>
      </CHeaderNavLink>
    </template>

    <CDropdownHeader tag="div" class="preika-account-dropdown__header">
      <span class="preika-account-avatar preika-account-avatar--large">{{ userInitial }}</span>
      <span>
        <strong>{{ name || 'ユーザー' }}</strong>
        <small>{{ authorityName || 'PREIKAメンバー' }}</small>
      </span>
    </CDropdownHeader>

    <CDropdownItem @click="goDashboard">
      <CIcon name="cil-speedometer"/>
      ダッシュボード
    </CDropdownItem>

    <CDropdownDivider/>

    <CDropdownItem class="preika-account-dropdown__logout" @click="invalidate">
      <CIcon name="cil-lock-locked"/>
      ログアウト
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import axios from 'axios'

export default {
  name: 'TheHeaderDropdownAccnt',

  data () {
    return {
      name: '',
      authorityName: ''
    }
  },

  computed: {
    userInitial () {
      const value = (this.name || 'P').trim()
      return value ? value.charAt(0).toUpperCase() : 'P'
    }
  },

  mounted () {
    this.fetchAccountInformation()
  },

  methods: {
    fetchAccountInformation () {
      Promise.all([
        axios.get(process.env.VUE_APP_API_ORIGIN + '/name'),
        axios.get(process.env.VUE_APP_API_ORIGIN + '/authority')
      ])
        .then(([nameResponse, authorityResponse]) => {
          this.name = nameResponse.data || ''
          this.authorityName = authorityResponse.data || ''
        })
        .catch(error => {
          console.error('アカウント情報の取得に失敗しました:', error)
        })
    },

    goDashboard () {
      if (this.$route.path !== '/dashboard') {
        this.$router.push('/dashboard')
      }
    },

    invalidate () {
      axios
        .get(process.env.VUE_APP_API_ORIGIN + '/invalid')
        .then(() => {
          sessionStorage.clear()
          alert('ログアウトしました')
          this.$router.push({ name: 'Login' })
        })
        .catch(error => {
          console.error('ログアウトに失敗しました:', error)
        })
    }
  }
}
</script>

<style scoped>
.preika-account-menu {
  display: flex;
  align-items: center;
  margin-right: 4px;
}

.preika-account-trigger {
  display: flex;
  min-height: 46px;
  align-items: center;
  gap: 10px;
  padding: 5px 10px !important;
  border: 1px solid var(--preika-gray-200);
  border-radius: 14px;
  background: rgba(255, 255, 255, .88);
  box-shadow: var(--preika-shadow-xs);
  color: var(--preika-text);
  cursor: pointer;
  transition: background var(--preika-transition-fast), border-color var(--preika-transition-fast), box-shadow var(--preika-transition-fast), transform var(--preika-transition-fast);
}

.preika-account-trigger:hover,
.preika-account-trigger:focus,
.preika-account-trigger:focus-within {
  border-color: var(--preika-blue-200);
  background: var(--preika-blue-050);
  box-shadow: 0 8px 20px rgba(15, 42, 64, .08), var(--preika-focus-ring);
  color: var(--preika-text);
  transform: translateY(-1px);
}

.preika-account-avatar {
  display: inline-flex;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  align-items: center;
  justify-content: center;
  border-radius: 11px;
  background: linear-gradient(145deg, var(--preika-blue-600), var(--preika-blue-800));
  box-shadow: 0 7px 15px rgba(10, 102, 178, .2);
  color: #fff;
  font-size: 13px;
  font-weight: 800;
}

.preika-account-avatar--large {
  width: 42px;
  height: 42px;
  flex-basis: 42px;
  border-radius: 13px;
  font-size: 15px;
}

.preika-account-copy {
  min-width: 0;
  text-align: left;
}

.preika-account-copy strong,
.preika-account-copy small,
.preika-account-dropdown__header strong,
.preika-account-dropdown__header small {
  display: block;
}

.preika-account-copy strong {
  max-width: 158px;
  overflow: hidden;
  color: var(--preika-navy-900);
  font-size: 11px;
  font-weight: 800;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.preika-account-copy small {
  margin-top: 1px;
  color: var(--preika-text-muted);
  font-size: 9px;
  line-height: 1.25;
}

.preika-account-chevron {
  width: 12px;
  margin-left: 1px;
  color: var(--preika-gray-400);
}

.preika-account-dropdown__header {
  display: flex;
  min-width: 250px;
  align-items: center;
  gap: 12px;
  padding: 17px 18px;
  background: linear-gradient(180deg, #fff, #f8fafc);
  text-align: left;
}

.preika-account-dropdown__header strong {
  color: var(--preika-navy-900);
  font-size: 12px;
}

.preika-account-dropdown__header small {
  margin-top: 2px;
  color: var(--preika-text-muted);
  font-size: 9px;
}

.preika-account-dropdown__logout {
  color: var(--preika-danger-600);
}

.c-icon {
  margin-right: 9px;
}

@media (max-width: 1199.98px) {
  .preika-account-copy strong {
    max-width: 112px;
  }
}

@media (max-width: 991.98px) {
  .preika-account-trigger {
    min-width: 46px;
    justify-content: center;
    padding: 5px !important;
  }
}
</style>
